import { Injector } from '@angular/core';

// allow $scope to be provided to ng1
export const ScopeProvider = {
	deps: ['$injector'],
	provide: '$scope',
	useFactory: (injector: Injector) => injector.get('$rootScope').$new()
};
